import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRouteWrapper = () => {
  const isAuthenticated = localStorage.getItem("authToken");
  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRouteWrapper;
